import {
  SERVING_HOLDING_TEMP_UNIT_DEFAULT,
  SERVING_HOLDING_TIME_UNIT_DEFAULT,
  PREPARATION_TIME_UNIT_DEFAULT,
  PRODUCTION_TIME_UNIT_DEFAULT,
  SECOND_SHELF_LIFE_UNIT_DEFAULT
} from './constants';

/**
 * Get ids for enrichment data objects. Returns id of both in progress and
 * published.
 *
 * Null is returned if no PPI in state exists.
 *
 * Example:
 * {
 *   inProgressId: '...',
 *   publishedId: '...'
 * }
 *
 * @param ppi
 * @returns {{inProgressId: *, publishedId: *}}
 */
function getEnrichmentIds(ppi) {
  const inProgressId = ppi.get('inProgressPPIEnrichmentData')
    ? ppi.get('inProgressPPIEnrichmentData').get('id')
    : null;
  const publishedId = ppi.get('publishedPPIEnrichmentData')
    ? ppi.get('publishedPPIEnrichmentData').get('id')
    : null;

  return {
    inProgressId,
    publishedId
  };
}

function filterByStatus(ppis, byStatus, secondStatus) {
  if (!byStatus) {
    return ppis;
  }
  return ppis.filter(ppi => {
    const hasInProgress = ppi.get('inProgressPPIEnrichmentData');
    const matchesInProgress =
      hasInProgress &&
      ppi.get('inProgressPPIEnrichmentData').get('enrichmentStatus') ===
        byStatus;

    const hasPublished = ppi.get('publishedPPIEnrichmentData');
    const matchesPublished =
      hasPublished &&
      (ppi.get('publishedPPIEnrichmentData').get('enrichmentStatus') ===
        byStatus ||
        ppi.get('publishedPPIEnrichmentData').get('enrichmentStatus') ===
          secondStatus);

    return matchesInProgress || matchesPublished;
  });
}

function getPpiDefaultData(
  languages,
  ingredient,
  firstStorageFromConfig,
  currLanguage
) {
  if (!ingredient) {
    throw new Error(
      'Unable to get PPI default values as no Ingredient is available'
    );
  }
  const getFirstStorageFromStockHierarchy = stockHierarchy => {
    let firstStorageCode = '';
    if (stockHierarchy !== null && stockHierarchy !== undefined) {
      for (const item in firstStorageFromConfig) {
        if (
          firstStorageFromConfig[item].codes.includes(stockHierarchy.toString())
        ) {
          firstStorageCode = firstStorageFromConfig[item].code;
          return firstStorageCode;
        }
      }
    }
    return firstStorageCode;
  };
  const defaultData = {
    info: {},
    referencedIngredientData: ingredient,
    itemCode: ingredient.itemCode,
    firstStorage: getFirstStorageFromStockHierarchy(ingredient.stockHierarchy),
    preparationTimeUnit: PREPARATION_TIME_UNIT_DEFAULT,
    secondShelfLifeUnit: SECOND_SHELF_LIFE_UNIT_DEFAULT,
    productionTimeUnit: PRODUCTION_TIME_UNIT_DEFAULT,
    servingHoldingTempUnit: SERVING_HOLDING_TEMP_UNIT_DEFAULT,
    servingHoldingTimeUnit: SERVING_HOLDING_TIME_UNIT_DEFAULT,
    relationshipId: ingredient.relationshipId
  };
  const { presentationName } = ingredient;
  languages.forEach(language => {
    defaultData.info[language] = {
      presentationName: presentationName[language]
    };
  });
  return defaultData;
}

export { getEnrichmentIds, filterByStatus, getPpiDefaultData };
